

import styled from 'styled-components';
import { FaLinkedinIn, FaTwitter, FaYoutube } from 'react-icons/fa';
import { FiPhone, FiPrinter, FiMail } from 'react-icons/fi';

import { colors, fonts } from '../shared/tokens';
import { Logo } from '../auth/authShared';

const COLUMNS = [
  {
    title: 'Sectors',
    items: ['Rail & Transit', 'Freight & Logistics', 'Energy & Infrastructure', 'Smart Facilities'],
  },
  {
    title: 'Platform',
    items: ['Features', 'Integrations', 'Security', 'System Requirements'],
  },
];

const CONTACT = [
  { icon: FiPhone, text: '+1 (514) 933-1649' },
  { icon: FiPhone, text: 'Toll Free: +1 (877) 933-1649' },
  { icon: FiPrinter, text: 'Fax: +1 (514) 933-2245' },
  { icon: FiMail, text: 'Sales@Temporaheaters.com' },
];

const LEGAL = ['Privacy Policy', 'Terms of Service', 'Security', 'Cookie Settings'];

const Footer = () => (
  <Wrap>
    <Inner>
      <Top>
        <Brand>
          <Logo />
          <Socials>
            <a href="#linkedin" aria-label="LinkedIn"><FaLinkedinIn /></a>
            <a href="#x" aria-label="X"><FaTwitter /></a>
            <a href="#youtube" aria-label="YouTube"><FaYoutube /></a>
          </Socials>
        </Brand>

        {COLUMNS.map((col) => (
          <Column key={col.title}>
            <ColTitle>{col.title}</ColTitle>
            <ul>
              {col.items.map((item) => (
                <li key={item}>
                  <a href="#">{item}</a>
                </li>
              ))}
            </ul>
          </Column>
        ))}

        <Column>
          <ColTitle>Get In Touch</ColTitle>
          <Contacts>
            {CONTACT.map(({ icon: Icon, text }) => (
              <li key={text}>
                <Icon />
                <span>{text}</span>
              </li>
            ))}
          </Contacts>
        </Column>
      </Top>

      <Bottom>
        <Copy>© 2026 Umbrella OS. All rights reserved.</Copy>
        <Legal>
          {LEGAL.map((l) => (
            <a key={l} href="#">{l}</a>
          ))}
        </Legal>
      </Bottom>
    </Inner>
  </Wrap>
);

export default Footer;

const Wrap = styled.footer`
  background: ${colors.bg};
  border-top: 0.75px solid ${colors.hairline};
`;

const Inner = styled.div`
  max-width: 1220px;
  margin: 0 auto;
  padding: 64px 80px 40px;

  @media (max-width: 768px) {
    padding: 48px 24px 32px;
  }
`;

const Top = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1.4fr;
  gap: 40px;

  @media (max-width: 820px) {
    grid-template-columns: 1fr 1fr;
    gap: 32px;
  }
  @media (max-width: 480px) {
    grid-template-columns: 1fr;
  }
`;

const Brand = styled.div`
  display: flex;
  flex-direction: column;
  gap: 22px;
`;

const Socials = styled.div`
  display: flex;
  gap: 8px;

  a {
    width: 34px;
    height: 34px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 6px;
    border: 0.75px solid ${colors.hairline};
    color: ${colors.muted};
    transition: color 0.15s ease, border-color 0.15s ease;
  }
  a:hover {
    color: ${colors.cyan};
    border-color: ${colors.cyanBorder};
  }
`;

const Column = styled.div`
  ul {
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-top: 16px;
  }
  a {
    font-family: ${fonts.body};
    font-size: 14px;
    color: ${colors.muted};
    text-decoration: none;
    transition: color 0.15s ease;
  }
  a:hover {
    color: ${colors.cyan};
  }
`;

const ColTitle = styled.h4`
  font-family: ${fonts.mono};
  font-weight: 500;
  font-size: 11px;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: ${colors.ink};
`;

const Contacts = styled.ul`
  li {
    display: flex;
    align-items: center;
    gap: 10px;
    color: ${colors.muted};
  }
  svg {
    flex-shrink: 0;
    color: ${colors.muted2};
  }
  span {
    font-family: ${fonts.body};
    font-size: 14px;
    color: ${colors.muted};
  }
`;

const Bottom = styled.div`
  margin-top: 52px;
  padding-top: 24px;
  border-top: 0.75px solid ${colors.hairline};
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;

  @media (max-width: 640px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

const Copy = styled.p`
  font-family: ${fonts.body};
  font-size: 13px;
  color: ${colors.muted2};
`;

const Legal = styled.div`
  display: flex;
  gap: 24px;
  flex-wrap: wrap;

  a {
    font-family: ${fonts.body};
    font-size: 13px;
    color: ${colors.muted2};
    text-decoration: none;
    transition: color 0.15s ease;
  }
  a:hover {
    color: ${colors.cyan};
  }
`;
